import { App, Button, Popconfirm } from 'antd';
import { useDeleteSourceMutation } from '@entities/source';
import { extractErrorMessage } from '@shared/api';

interface Props {
  sourceId: string;
  sourceName: string | null;
  assistantId: string;
}

/**
 * Удаление источника. Бэк удаляет запись в БД (CASCADE на чанки и
 * картинки), S3-файл остаётся как orphan — известный долг бэка.
 *
 * После успеха инвалидируется список источников и карточка пропадает.
 */
export function DeleteSourceButton({ sourceId, sourceName, assistantId }: Props) {
  const { message } = App.useApp();
  const mutation = useDeleteSourceMutation(assistantId);

  const handleConfirm = async () => {
    try {
      await mutation.mutateAsync(sourceId);
      message.success(sourceName ? `«${sourceName}» удалён` : 'Документ удалён');
    } catch (err) {
      message.error(extractErrorMessage(err));
    }
  };

  return (
    <Popconfirm
      title="Удалить документ?"
      description="Удалятся также все извлечённые из него фрагменты. Действие необратимо."
      okText="Удалить"
      cancelText="Отмена"
      okButtonProps={{ danger: true, loading: mutation.isPending }}
      onConfirm={handleConfirm}
      placement="topRight"
    >
      <Button size="small" type="text" danger>
        Удалить
      </Button>
    </Popconfirm>
  );
}
